import {getIconIdByServicePath, getRandomInt} from './util/itemHunterUtil';
import { callClikcItemIcom } from './service';
import Itemhunter from './Itemhunter';
import { displayMesssage, msgSubstitution } from './util/messageUtil';
import { MAPPED_CODE_TO_MESSAGE } from './Message';
import axios from 'axios';
import { ApiErrorData, getErrorMessage, getErrorResult } from './util/errorMessageUtil';

const ERROR_CODE_UNAUTHORIZED_USER_ID = 'p20211025.iconsEvent.UNAUTHORIZED_USER_ID';
// const POSITIONS_PC = [[100,100]]; // [[top, left]]
// const POSITIONS_MO = [[100,100]]; // [[top, left]]
const POSITIONS_PC = [[5,50], [5,95], [50,10], [50,50], [50,95], [100,10], [100,50], [100,95],]; // [[top, left]]
const POSITIONS_MO = [[5,10], [5,50], [50,10], [50,50], [50,95], [100,10], [100,50], [100,95],]; // [[top, left]]
const BtnCloseSelector = 'btn-close';
const ContentSelector = 'item-hunter-content';
const MAXIMUM_ICON_QUANTITY_PER_ITEM = 1;
const COUNT_TYPE_OF_ICON = 1;


export default class CreateIteam {
  targetPosition: number[];
  $itemIcon!: HTMLElement;
  $btnClose?: null | HTMLElement;
  $content?: null | HTMLElement;

  isLoginFlag: boolean;
  isCallingApi: boolean;
  iconId: string;
  basePosition: number[][];
  zIndex: number;
  itemhunter: Itemhunter;
  ICON_ID: string;
  API_DOMAIN: string;
  EVENT_CODE: string;

  constructor({itemhunter, zIndex, isLogin, iconId, apidomain, eventCode}:{itemhunter: Itemhunter, zIndex:number, isLogin: boolean, iconId: string, apidomain: string, eventCode:string} ){
    this.zIndex = zIndex;
    this.ICON_ID = iconId;
    this.API_DOMAIN = apidomain;
    this.EVENT_CODE = eventCode;
    this.isCallingApi = false;
    this.basePosition = window.innerWidth >= 960 && POSITIONS_PC || POSITIONS_MO;

    this.targetPosition = this.basePosition[getRandomInt(0, this.basePosition.length - 1)];

    this.isLoginFlag = isLogin;

    this.itemhunter = itemhunter;

    this.iconId = iconId;

    this.create();

    console.log('position:',this.targetPosition);
    return;

  }

  create() {
    // 템플릿 만들고
    this.makeTemplate();

    console.log(this.$itemIcon);

    /*
    this.$content?.addEventListener('click', ()=>{
      const message = MAPPED_CODE_TO_MESSAGE['SUCCESS_CATCH'];

      displayMesssage({
        message: message,
        msgType:{type:'ncui.modal'}
      });
    });
    */

    // 템플릿에 이벤트 넣고
    this.$content?.addEventListener('click', this.onClickItemIcon);
    this.$btnClose?.addEventListener('click', this.onClickBtnClose);

    // 붙이고
    document.body.appendChild(this.$itemIcon);

    // 렌덤위치로 보내고 보여준다.
    this.$itemIcon.style.top = `${this.topPosition}%`;
    this.$itemIcon.style.left = `${this.leftPosition}%`;
    this.$itemIcon.style.display = 'block';
    // if(this.leftPosition === 50 || this.leftPosition === 80){
      this.$itemIcon.style.transform = `translate(-${this.leftPositionReverse}px, -${this.topPositionReverse}px)`;
    // }
  }

  // 닫기 버튼 클릭
  onClickBtnClose = (evt: MouseEvent)  => {
    // 삭제
    this.delete();
  };

  // 아이템 클릭
  onClickItemIcon = async(evt: MouseEvent) => {

    // 로그아웃 유저의 경우
    if(!this.isLoginFlag){
      if(typeof(window.GNBLogin) === 'function'){
        window.GNBLogin() ;
      }else{
        console.error('GNBLogin 이 정의 되어 있지 않습니다.');
      }
      return;
    }

    if(this.isCallingApi) return;

    // 로그인 유저의 경우
    try{
      this.isCallingApi = true;

      // 서버에 클릭했다고 알린다.
      const catchedItemList = await callClikcItemIcom(this.API_DOMAIN, {eventCode: this.EVENT_CODE, iconId: String(this.iconId)});
      const hasBeenGotCurIdIcon = catchedItemList.find(icon => String(icon.iconId) == this.ICON_ID)!;
      const countHasBeenGotIcons = catchedItemList.filter(icon => icon.iconCount >= 1)!.length;

      let message;

      // 4종류 모두 전부 수집
      if(catchedItemList.every(item => item.iconCount >= item.maxIconCount)){
        message = MAPPED_CODE_TO_MESSAGE['SUCCESS_CATCH_ALL'];
      }else{
        message = MAPPED_CODE_TO_MESSAGE['SUCCESS_CATCH'];

        // 메시지 보간법 사용해야 변경되어야 할때
        /*
        // message = msgSubstitution({
        //   msg: MAPPED_CODE_TO_MESSAGE['SUCCESS_CATCH'],
        //   msgArgs: {
        //     quantity: String(countHasBeenGotIcons),
        //     total: String(COUNT_TYPE_OF_ICON)
        //   }
        // });
        */
      }

      displayMesssage({
        message: message,
        msgType:{type:'ncui.modal'}
      });

    }catch(error){

      if (axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
        const errorResult = getErrorResult(error.response.data);

        if(errorResult.errorCode === ERROR_CODE_UNAUTHORIZED_USER_ID){
          if(typeof(window.GNBLogin) === 'function'){
            window.GNBLogin() ;
          }else{
            console.error('GNBLogin 이 정의 되어 있지 않습니다.');
          }
          return;
        }

        const errorMessage= getErrorMessage(errorResult, MAPPED_CODE_TO_MESSAGE, {DEFAULT_ERROR_MESSAGE: MAPPED_CODE_TO_MESSAGE['DEFAULT_ERROR_MESSAGE'], localFirst: true, usingServerMsg: true});

        displayMesssage({
          message: errorMessage,
          msgType:{type:'alert'}
        });
      }


    }finally{
      // finally
      this.isCallingApi = false;

      // 템플릿에 이벤트 빼고 (메모리 관련)
      this.$content?.removeEventListener('click', this.onClickItemIcon);
      this.$btnClose?.removeEventListener('click', this.onClickBtnClose);
    }

    // 삭제
    this.delete();

    // 다시 첨부터 시작
    // 만약,  규모가 좀더 큰 프로젝터였다면, itemhunter 인스턴스를 직접 사용하는게 아니라, deleteCallback() 같은걸 인자로 받았어야 할까?
    this.itemhunter.init();
    // 일단 밑에 꺼보다는 나은듯
    // new Itemhunter({minSec:TIMER_MAX_SEC,  maxSec:TIMER_MIN_SEC, zIndex: ZINDEX});
  };

  // 템플릿 삭제
  delete() {
    this.$itemIcon.parentNode!.removeChild(this.$itemIcon);

    this.$content = null;
    this.$btnClose = null;

  }

  // [TODO] 템플릿 만들기
  makeTemplate() {
    let wrapper = document.createElement('div');
    wrapper.id = 'itemHunterWrap';
    wrapper.style.zIndex = String(this.zIndex);

    this.$btnClose = document.createElement('div');
    this.$btnClose.className = BtnCloseSelector;

    this.$content = document.createElement('div');
    this.$content.className = ContentSelector;
    this.$content.dataset.iconId = String(this.iconId);

    wrapper.appendChild(this.$btnClose);
    wrapper.appendChild(this.$content);

    this.$itemIcon = wrapper;

    return wrapper;
  }

  get topPosition(){
    return this.targetPosition[0];
  }

  get topPositionReverse(){
    const topPosition = this.targetPosition[0];

    // 60은 퍼플 하단 cnb 높이
    if(topPosition >= 90){
      return Math.ceil(this.$content!.offsetHeight * topPosition / 100) + 60;
    }else{
      return Math.ceil(this.$content!.offsetHeight * topPosition / 100);
    }
  }


  get leftPosition(){
    return this.targetPosition[1];
  }

  get leftPositionReverse(){
    const leftPosition = this.targetPosition[1];

    return Math.ceil(this.$content!.offsetHeight * leftPosition / 100);
  }

}

// function GNBLogin(){
//   let returnurl = '?return_url=' + escape(document.location.href);
//   let loginURL = '[(${@environment.getProperty(\'ui.loginUrl\')})]';
//   document.location.href = loginURL + (loginURL.indexOf('?') > 0 ? '&'+returnurl.substring(1) : returnurl);
// }

